export const PRODUCT_PRICE_MODEL = {
  PER_CATEGORY: 'PER_CATEGORY',
  RECURRING: 'RECURRING',
  NON_RECURRING: 'NON_RECURRING',
  ALL: 'ALL',
};

export const PRODUCT_PRICE_MODEL_LIST = Object.values(PRODUCT_PRICE_MODEL);
